module.exports = __webpack_public_path__ + "img/lease.bbd9861f.png";